import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import client from '../feathers';
import { getAnonAddresses } from '../util/connections';
import { isTokenValid } from '../util/token';
import useWalletError from '../hooks/useWalletError';
import useAuth from '../hooks/useAuth';
import useIntl from '../hooks/useIntl';
import { useProgressDialog } from '../context/ProgressDialogProvider';
import useSentry from '../hooks/useSentry';

export const useBills = (filter, doRefreshBills, showBackdrop, doGrouping) => {
  const [state, setState] = useState({
    bills: undefined,
    anonAddresses: [],
  });

  const onWalletError = useWalletError();
  const { user } = useAuth();
  const { showProgressDialog, hideProgressDialog } = useProgressDialog();
  const history = useHistory();
  const { translate } = useIntl();
  const logSentry = useSentry();

  const fetchBills = async () => {
    if (!isTokenValid()) {
      onWalletError(new Error(translate('session.expired')));
      history.push('/');
      return;
    }

    let { anonAddresses } = state;
    if (anonAddresses.length === 0) {
      try {
        anonAddresses = await getAnonAddresses(user);
      } catch (error) {
        onWalletError(error);
      }
    }

    const { data } = await client.service('bills-of-lading').find({
      query: {
        addresses: anonAddresses,
        doGrouping: doGrouping,
        $filter: filter,
      },
    });
    setState({ ...state, anonAddresses, bills: data });
  };

  useEffect(() => {
    try {
      showBackdrop && showProgressDialog();
      doRefreshBills && fetchBills();
    } catch (e) {
      logSentry(e);
      onWalletError(e);
    } finally {
      showBackdrop && hideProgressDialog()
    }
  }, [filter, doRefreshBills]);

  useEffect(() => {
    console.log("anonAddresses", state.anonAddresses)
  }, [state.anonAddresses]);

  return { ...state };
};
